<div class="style-admin-container">
    <!-- Header -->
    <div class="style-header">
        <div class="header-content">
            <h1 class="style-title">
                <fa-icon [icon]="icons.faPalette" class="title-icon"></fa-icon>
                Background Management
            </h1>
            <p class="style-subtitle">Customize the look and feel of your board's viewer</p>
        </div>
    </div>

    <!-- Main Content -->
    <div class="style-content">
        <!-- Upload Section -->
        <div class="upload-section">
            <div class="upload-header">
                <h2 class="section-title">
                    <fa-icon [icon]="icons.faCloudUploadAlt" class="section-icon"></fa-icon>
                    Upload Custom Background
                </h2>
                <p class="section-description">Add a new custom background to your board</p>
            </div>

            <div class="upload-area">
                <div class="upload-input-wrapper">
                    <input 
                        type="file" 
                        id="filePicker" 
                        class="file-input"
                        (change)="selectFile($event)"
                        accept="image/*">
                    <label for="filePicker" class="file-input-label">
                        <div class="file-input-content">
                            <div class="upload-icon">🎨</div>
                            <p class="upload-text">
                                <span class="upload-highlight" *ngIf="!selectedFile">Click to select or drag a file here</span>
                                <span *ngIf="selectedFile" class="file-selected">{{ selectedFile.name }}</span>
                            </p>
                            <p class="upload-hint">PNG, JPG up to 10MB</p>
                        </div>
                    </label>
                </div>

                <!-- Upload Status -->
                <div *ngIf="uploadStatus" class="upload-status">
                    <div class="status-content">
                        <span class="status-label">{{ uploadStatus }}</span>
                        <span class="upload-progress">{{ uploadPercent }}</span>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar" [ngStyle]="{'width': uploadPercent}"></div>
                    </div>
                </div>

                <!-- Upload Button -->
                <button 
                    class="btn btn-primary"
                    (click)="uploadFile()"
                    [disabled]="!selectedFile || uploadStatus">
                    <fa-icon [icon]="icons.faUpload" class="btn-icon"></fa-icon>
                    <span class="btn-text">Upload Background</span>
                </button>
            </div>
        </div>

        <!-- Backgrounds Gallery Section -->
        <div class="gallery-section">
            <div class="gallery-header">
                <h2 class="section-title">
                    <fa-icon [icon]="icons.faImages" class="section-icon"></fa-icon>
                    Available Backgrounds
                </h2>
                <p class="section-description">Select which background to display in your board</p>
            </div>

            <!-- Built-in Backgrounds -->
            <div class="background-subsection">
                <h3 class="subsection-title">Built-in Backgrounds</h3>
                <div class="background-gallery">
                    <div 
                        *ngFor="let url of builtInBackgrounds" 
                        class="background-item"
                        [class.selected]="fullImg(url)==selectedBackground">
                        <div 
                            class="background-preview"
                            [ngStyle]="{
                                'background': 'url(' + thumbnailImg(url) + ') 0% 0% / cover'
                            }"
                            (click)="selectBackground(fullImg(url))">
                            <div class="preview-overlay">
                                <span class="check-icon" *ngIf="fullImg(url)==selectedBackground">
                                    <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                                </span>
                            </div>
                        </div>
                        <div class="background-label">
                            <span *ngIf="fullImg(url)==selectedBackground" class="selected-badge">
                                <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                                Active
                            </span>
                            <span *ngIf="fullImg(url)!=selectedBackground" class="inactive-badge">
                                Click to use
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Backgrounds -->
            <div class="background-subsection" *ngIf="customBackgrounds.length > 0">
                <h3 class="subsection-title">Custom Backgrounds</h3>
                <div class="background-gallery">
                    <div 
                        *ngFor="let bg of customBackgrounds" 
                        class="background-item"
                        [class.selected]="bg.url==selectedBackground">
                        <div 
                            class="background-preview"
                            [ngStyle]="{
                                'background': 'url(' + imgUrl(bg) + ') 0% 0% / cover'
                            }"
                            (click)="selectBackground(bg.url)">
                            <div class="preview-overlay">
                                <button 
                                    class="btn-delete"
                                    title="Delete Background"
                                    (click)="deleteBackground(bg)">
                                    <fa-icon [icon]="icons.faTrash"></fa-icon>
                                </button>
                                <span class="check-icon" *ngIf="bg.url==selectedBackground">
                                    <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                                </span>
                            </div>
                        </div>
                        <div class="background-label">
                            <span *ngIf="bg.url==selectedBackground" class="selected-badge">
                                <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                                Active
                            </span>
                            <span *ngIf="bg.url!=selectedBackground" class="inactive-badge">
                                Click to use
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
